import {Dispatch, FC} from 'react';
import {getProcessActionsToastMessage} from '../../../constants/constants';
import {useSnackbarHook} from '../../../hooks/useSnackbar';
import ConfirmationPopup from '../../common/popup/ConfirmationPopup';
import {startProcessAction} from '../helpers';
import {ProcessActionPopupData} from '../types';

type ProcessAssigneePopupProps = {
  processActionsPopupData: Nullable<ProcessActionPopupData>,
  setProcessActionsPopupData: Dispatch<Nullable<ProcessActionPopupData>>,
  isActionProcessing: boolean,
  setIsActionProcessing: Dispatch<boolean>,
  getProcessData: () => Promise<void>
}

const ProcessAssigneePopup: FC<ProcessAssigneePopupProps> = ({
  processActionsPopupData, setProcessActionsPopupData,
  isActionProcessing, setIsActionProcessing, getProcessData
}) => {
  const {addSuccessToast, addErrorToast} = useSnackbarHook();

  const makeProcessAction = async () => {
    if (processActionsPopupData) {
      const {id, type, assigneeId} = processActionsPopupData;

      setIsActionProcessing(true);

      try {
        await startProcessAction(id, type, assigneeId);

        await getProcessData();

        const toastMessage =
        getProcessActionsToastMessage(type);
        addSuccessToast(toastMessage);
      } catch (error) {
        addErrorToast(error.message);
      } finally {
        setIsActionProcessing(false);
        setProcessActionsPopupData(null);
      }
    }
  };

  return (
    <>
      {processActionsPopupData && (
        <ConfirmationPopup
          labels={
            {
              body: processActionsPopupData.message,
              confirmBtn: processActionsPopupData.confirmBtn
            }
          }
          isOpen={!!processActionsPopupData}
          setIsOpen={() => setProcessActionsPopupData(null)}
          confirmableAction={() => makeProcessAction()}
          isActionProcessing={isActionProcessing}
        />
      )}
    </>
  );
};


export default ProcessAssigneePopup;
